export const conversationJtbdMapping = (
  t: (key: string) => string,
): Record<string, Record<string, string>> => ({
  completed: {
    emoji: '✅',
    text: t('conversationShowGeneralJtbdCompleted'),
    color: 'success',
    bgColor: 'var(--success-100)',
    textColor: 'var(--success-700)',
    borderColor: 'var(--success-300)',
  },
  failed: {
    emoji: '❌',
    text: t('conversationShowGeneralJtbdFailed'),
    color: 'error',
    bgColor: 'var(--error-100)',
    textColor: 'var(--error-700)',
    borderColor: 'var(--error-300)',
  },
})

export const getConversationJtbdDisplay = (
  t: (key: string) => string,
  isCompleted: boolean | undefined,
) => {
  return isCompleted
    ? conversationJtbdMapping(t).completed
    : conversationJtbdMapping(t).failed
}
